var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',[_vm._v("temp route")]),_c('div',[_c('router-link',{attrs:{"to":"/login"}},[_vm._v("Go to Login")])],1),_c('div',[_c('router-link',{attrs:{"to":"/list"}},[_vm._v("Go to List")])],1),_c('div',[_c('router-link',{attrs:{"to":"/table"}},[_vm._v("Go to Table")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }